import { styled } from '@mui/material';

import EDTypography from '../../Typography/EDTypography';

interface IProps {
  resourceName: string;
  isSmallScreen?: boolean;
}

export const EDCalendarViewResourceNameCell: React.FC<IProps> = props => {
  return props.isSmallScreen ? (
    <ResourceNameTypographyMobile>
      {props.resourceName}
    </ResourceNameTypographyMobile>
  ) : (
    <ResourceNameTypography>{props.resourceName}</ResourceNameTypography>
  );
};

const ResourceNameTypography = styled(EDTypography, {
  name: 'ResourceTypography',
})(({ theme }) => ({
  fontSize: 14,
  lineHeight: 1.2,
  display: 'block',
  wordBreak: 'break-word',
  fontWeight: 'bold',
  padding: theme.spacing(1, 1.5),
}));

const ResourceNameTypographyMobile = styled(EDTypography, {
  name: 'ResourceTypography',
})(({ theme }) => ({
  fontSize: 10,
  lineHeight: 1.2,
  display: 'block',
  wordBreak: 'break-word',
  fontWeight: 'bold',
  padding: theme.spacing(1, 1.5),
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '-webkit-fill-available',
}));
